import { observer } from 'mobx-react-lite';
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom';


const ForSpecialists: FC = () => {

    const navigate = useNavigate()

    return (
        <div className='row pt-5 m-3'>
            <div className='col-md-6' onClick={() => navigate('/specialist/recs/')} style={{ cursor: 'pointer' }}>
                <img src="/images/recs.jpg" alt="Рекомендации" />
            </div>
            <div className='col-md-6' onClick={() => navigate('/specialist/materials/')} style={{ cursor: 'pointer' }}>
                <img src="/images/materials.jpg" alt="Материалы" />
            </div>
        </div>
    );
};
export default observer(ForSpecialists);